export function stepPersonalDetailsBuilderUI(details) {
  return {
    ...details
  };
}

export function emailExistBuilderUI(details) {
  return {
    ...details
  };
}
